<template>
    <div>
        <PageHeader/>
        <section id="qna">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="list-wrap">
                            <div class="slider-wrap">
                                <div class="slider qna-slider">
                                    <div v-for="(data, key) in all_datas.all_questions" :class="`qna-id${data.cate_id+1}`">
    
                                        <router-link :to="{ name: data.alias, params: { title: data.alias }}" :class="key">
                                            <div class="text-wrap" v-html="data.title">
                                            </div>
                                        </router-link>
                                    </div>

                                    <!-- <div v-for="(data, key) in all_datas.all_questions" :class="`qna-id${data.cate_id+1}`">
    
                                        <router-link :to="{ name: data.alias, params: { title: data.alias }}" :class="key">
                                            <div class="text-wrap" v-html="data.title">
                                            </div>
                                        </router-link>
                                    </div> -->

                                    
                                    
                                    
                                </div>
                            </div>

                            <mylist :all_questions="all_datas.all_questions"/>
                        

                        </div>
                    </div>
                </div>
            </div>
            <ToTopBtn/>
        </section>
    </div>
    
</template>
<script>


import axios from 'axios';

import mylist from './list';
import PageHeader from '../subview/PageHeader.vue';
import ToTopBtn from '../subview/ToTopBtn.vue';


export default {
	components: {
        mylist,
        PageHeader,
        ToTopBtn
	},
	data(){
		return {
            all_datas: "",
			json_src: './src/assets/json/qna.json'
		}
	},
	methods: {
		get_datas() {
            axios.get(this.json_src).then((response) => {
                
                console.log(response.data)
                this.all_datas = response.data;


                this.ga_func(".questions_act", "常見問題-活動相關");
                this.ga_func(".questions_brand", "常見問題-品牌、產地、服務相關");
                this.ga_func(".questions_report", "常見問題-檢驗報告");
                this.ga_func(".questions_notice", "常見問題-產品使用注意事項");
                
            }, (error) => {
            	console.log(error)
            })
        },
        qa_slide(){
            $('.slider.qna-slider').slick({
                focusOnSelect: true,
                variableWidth: false,
                infinite: true,
                dots: false,
                slidesToShow: 4,
                swipeToSlide: true,
                prevArrow:`
                    <svg class='a-left control-c prev slick-prev' version="1.1" id="圖層_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 42 24" style="enable-background:new 0 0 42 24;" xml:space="preserve">
                <style type="text/css">
                    .st0{fill:#6D6D6D;}
                </style>
                <path class="st0" d="M0,12l12,12h6L6,12L18,0h-6L0,12z M12,12l12,12h6L18,12L30,0h-6L12,12z M24,12l12,12h6L30,12L42,0h-6L24,12z"/>
                </svg>`,
                    nextArrow:`<svg class='a-right control-c next slick-next' version="1.1" id="圖層_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 42 24" style="enable-background:new 0 0 42 24;" xml:space="preserve">
                <style type="text/css">
                    .st0{fill:#6D6D6D;}
                </style>
                <path class="st0" d="M30,0h-6l12,12L24,24h6l12-12L30,0z M18,0h-6l12,12L12,24h6l12-12L18,0z M6,0H0l12,12L0,24h6l12-12L6,0z"/>
                </svg>`,
                responsive: [
                    {
                    breakpoint: 992,
                    settings: {
                        focusOnSelect: true,
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        variableWidth: true,
                        
                        //infinite: true,
                        }
                    },
                    {
                    breakpoint: 600,
                    settings: {
                        focusOnSelect: true,
                        slidesToShow: 3,
                        slidesToScroll: 2,
                        variableWidth: true,
                        }
                    },
                    {
                    breakpoint: 480,
                    settings: {
                        focusOnSelect: true,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        variableWidth: true,
                        }
                    }
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ],

            })


        },
        cur_slick_click(){
            $('.slider.qna-slider').on('afterChange', (event, slick, cur)=>{
                $(`.slider.qna-slider .slick-slide[data-slick-index=${cur}] a`)[0].click()
            })
        },
        ga_func(class_name, name){
            $("body").on('click', class_name, function (e) {
                //alert()
                gtag('event', '點擊', {
                    'event_category': name,
                    'event_action': '點擊',
                    'event_label': '點擊次數'
                });
            });
        }
		
    },
	computed: {
		
	},
	mounted(){
		this.get_datas();

        $("HTML, BODY").animate({ scrollTop: 0 }, 500);
		// $(".custom-scroller").mCustomScrollbar({
		// 	theme: "rounded-dots",
		// 	mouseWheelPixels: 80,
		// 	scrollInertia: 0
		// });
		
		
    },
    updated(){
        this.qa_slide();
        this.cur_slick_click();
    }
}
</script>


<style lang="sass">

section#qna

    &:before
        content: ''
        background-image: url('../assets/qna-bg.png')
        position: fixed
        display: block
        top: 0
        left: 0
        width: 100%
        height: 100%
        background-size: cover
        background-position: center bottom
        transform: translateZ(0)
        will-change: transform
        z-index: -1000
    
    .slider-wrap
        padding: 0 50px
        padding-top: 20px
        .qna-slider
            border-bottom: 1px solid
        .text-wrap
            padding: 15px 2px
            cursor: pointer
            font-size: 16px
            letter-spacing: 2px
            font-weight: 400
            text-align: center
            @media (max-width: 991px)
                padding: 15px 20px

        .slick-arrow
            width: 23px
            fill: #999
            -webkit-filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.4))
            filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.4))
            .st0
                -webkit-transition: .3s
                -o-transition: .3s
                transition: .3s
            &:hover .st0
                fill: #4ba6a3
        .slick-slide
            position: relative
        a
            outline: none
            text-decoration: none
            color: black
            &:before
                content: ""
                width: 100%
                height: 100%
                position: absolute
                top: 50%
                left: 50%
                -webkit-transform: translate(-50%, -50%)
                -ms-transform: translate(-50%, -50%)
                transform: translate(-50%, -50%)
                z-index: -1
            &:hover:before
                -webkit-transition: .3s
                -o-transition: .3s
                transition: .3s
                background: #ebebeb
        .a-left
            left: -30px
        .a-right
            right: -30px
    .list-wrap .main-title h1
        text-align: center
        span
            display: inline-block
    .bottom-list-wrap
        .qa-li
            margin-bottom: 10px
        .qa-div
            display: -webkit-box
            display: -ms-flexbox
            display: flex
            div
                text-align: justify
                font-weight: 300
                line-height: 30px
            .char
                width: 30px
                white-space: nowrap
            .text
                -webkit-box-flex: 1
                -ms-flex: 1
                flex: 1
                .inner-ul
                    padding: 0
                    .inner-li
                        list-style: none
        .q div
            color: #4ba6a3
    .custom-scroller
        height: 60vh
    .ways-li
        margin-bottom: 25px
        .ways-title
            font-size: 20px
            margin-bottom: 5px
        .all-ways
            padding-left: 10px
            .way
                line-height: 27px
                font-weight: 300
                margin-bottom: 10px
                display: -webkit-box
                display: -ms-flexbox
                display: flex
                -ms-flex-flow: wrap
                flex-flow: wrap
                .num
                    width: 25px
                .text
                    text-align: justify
                    -webkit-box-flex: 1
                    -ms-flex: 1
                    flex: 1
        .sub-list
            padding-left: 50px
            margin-top: 10px
            -webkit-box-flex: 1
            -ms-flex: 1 100%
            flex: 1 100%
    .item-wrap
        text-align: center
        margin-top: 30px
        margin-bottom: 50px
        img
            width: 100%
        .name
            text-align: center
            min-height: 50px
            font-size: 21px
        .download-btn
            padding: 8px 40px
            border-radius: 5px
            font-weight: 300
            border: none
            color: white
            background: #999
            -webkit-transition: .3s
            -o-transition: .3s
            transition: .3s
            cursor: pointer
            white-space: nowrap
            &:hover
                background: #4ba6a3
    .report-list
        display: flex
        flex-wrap: wrap
        .item-wrap
            width: 25%
            @media (max-width: 991px)
                width: 50%
            @media (max-width: 576px)
                width: 100%

    .slick-current
        background: #4ba6a3
        *
            color: white
            font-weight: 300 !important

@media (max-width: 991px)
    section#qna .slider-wrap
        padding: 0 30px
        padding-top: 20px

@media (max-width: 768px)
    section#qna .slider-wrap
        padding: 0 0px
        padding-top: 20px

@media (max-width: 576px)
    section#qna .item-wrap .download-btn
        padding: 6px 35px
        font-size: 14px

</style>



// WEBPACK FOOTER //
// src/Qna/main.vue